import { a as isArrayLike_1, b as isTypedArray_1, c as isArray_1, i as isEmpty_1 } from './isEmpty-ea893565.js';
import { p as pick_1 } from './pick-8e119733.js';
import { e as eq_1, a as _Stack } from './_Stack-cf94d4e7.js';
import { _ as _baseAssignValue, k as keysIn_1 } from './keysIn-b6895676.js';
import { _ as _baseFor } from './_baseFor-a28737de.js';
import { _ as _copyObject, a as _copyArray, b as _cloneBuffer, c as _cloneTypedArray, i as isPlainObject_1, d as _initCloneObject } from './_copyObject-3791899f.js';
import { i as isObjectLike_1, a as isBuffer_1, b as isArguments_1, c as isObject_1, d as isFunction_1 } from './_nodeUtil-549406aa.js';
import { i as identity_1 } from './_arrayLikeKeys-26c55d84.js';
import { a as _setToString, b as _overRest } from './_flatRest-cc9038d0.js';
import { _ as _isIndex } from './_isIndex-3036d479.js';
import { Z as addPageLoadDataInfoToAnalyticsEvent, o as parseJsonResponse, ao as store, at as startLoading, ap as ACTION_TYPES, aO as SprykerProductsAll, $ as getBrandName, aQ as SprykerDdcConfig, au as setCircularProductData, aw as stopLoading, av as setError, K as getCTAClickEventParams } from './index-39f51a91.js';
import { q as CircularProductTypes, K as ECarouselRelation, U as ETabType } from './currency-49e0d692.js';
import { C as CR } from './constants-7d3b1dc0.js';
import { b as getCountry, d as getLanguage } from './helpers-cd261aee.js';
import { p as priceToFloat } from './number-fcf5283d.js';
import { t as triggerCtaClickEvent } from './analytics-74fe4f64.js';

var ExternalUrlConfigAction;
(function (ExternalUrlConfigAction) {
  ExternalUrlConfigAction["VIEW_DETAIL"] = "viewDetail";
  ExternalUrlConfigAction["SUBSTITUTION"] = "substitution";
})(ExternalUrlConfigAction || (ExternalUrlConfigAction = {}));
var ExternalUrl;
(function (ExternalUrl) {
  ExternalUrl["DEFAULT"] = "#";
})(ExternalUrl || (ExternalUrl = {}));

const generateExternalURL = (action, externalUrlConfig, product) => {
  var _a;
  if (!externalUrlConfig)
    return ExternalUrl.DEFAULT;
  const actionUrl = (_a = externalUrlConfig[action]) !== null && _a !== void 0 ? _a : [];
  const copyOfUrl = [...actionUrl];
  if (!copyOfUrl.length)
    return ExternalUrl.DEFAULT;
  copyOfUrl.forEach((urlFragment, index) => {
    const keyName = urlFragment.replace('${', '').replace('}', '');
    if (!(product === null || product === void 0 ? void 0 : product.hasOwnProperty(keyName)))
      return;
    copyOfUrl[index] = product[keyName];
  });
  return copyOfUrl.join('');
};

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq_1(object[key], value)) ||
      (value === undefined && !(key in object))) {
    _baseAssignValue(object, key, value);
  }
}

var _assignMergeValue = assignMergeValue;

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike_1(value) && isArrayLike_1(value);
}

var isArrayLikeObject_1 = isArrayLikeObject;

/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

var _safeGet = safeGet;

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return _copyObject(value, keysIn_1(value));
}

var toPlainObject_1 = toPlainObject;

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = _safeGet(object, key),
      srcValue = _safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    _assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray_1(srcValue),
        isBuff = !isArr && isBuffer_1(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray_1(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray_1(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject_1(objValue)) {
        newValue = _copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = _cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = _cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject_1(srcValue) || isArguments_1(srcValue)) {
      newValue = objValue;
      if (isArguments_1(objValue)) {
        newValue = toPlainObject_1(objValue);
      }
      else if (!isObject_1(objValue) || isFunction_1(objValue)) {
        newValue = _initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  _assignMergeValue(object, key, newValue);
}

var _baseMergeDeep = baseMergeDeep;

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  _baseFor(source, function(srcValue, key) {
    stack || (stack = new _Stack);
    if (isObject_1(srcValue)) {
      _baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(_safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      _assignMergeValue(object, key, newValue);
    }
  }, keysIn_1);
}

var _baseMerge = baseMerge;

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return _setToString(_overRest(func, start, identity_1), func + '');
}

var _baseRest = baseRest;

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject_1(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike_1(object) && _isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq_1(object[index], value);
  }
  return false;
}

var _isIterateeCall = isIterateeCall;

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return _baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && _isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

var _createAssigner = createAssigner;

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = _createAssigner(function(object, source, srcIndex) {
  _baseMerge(object, source, srcIndex);
});

var merge_1 = merge;

const softwareDocumentsToSoftwareInfo = (softwareDocuments, labels) => {
  if (!isEmpty_1(labels)) {
    return Object.assign(Object.assign({}, pick_1(labels, [
      'availableVersionsLabel',
      'operatingSystemsLabel',
      'languageLabel',
      'formatLabel',
      'sizeLabel',
      'dateLabel',
      'versionLabel',
      'downloadLabel',
      'viewLabel',
    ])), { softwareDocuments });
  }
  return null;
};
const requestCrProductSelectorAvailability = (selectorConfig) => fetch(selectorConfig.scUrl, {
  headers: { Authorization: selectorConfig.token },
}).then((res) => parseJsonResponse(res));
const setProductSelectorAvailability = async (selectorConfig, productSelectorConfig) => {
  let showProductSelector;
  if (productSelectorConfig.type === CR) {
    const { status } = await requestCrProductSelectorAvailability(selectorConfig);
    showProductSelector = status;
  }
  else {
    showProductSelector = true;
  }
  return showProductSelector;
};
const formatPrice = (price) => (price ? priceToFloat(price) : 'undefined');
const gatherDataForViewItemAnalyticsEvent = (productId, productInfo, ctaArea, productAvailabilityInfo, isApc) => {
  var _a, _b, _c, _d, _e;
  return Object.assign({ template_name: 'Products', items: [
      {
        item_brand: (_a = productInfo === null || productInfo === void 0 ? void 0 : productInfo.brand) !== null && _a !== void 0 ? _a : '',
        item_id: productId !== null && productId !== void 0 ? productId : '',
        item_name: (_b = productInfo === null || productInfo === void 0 ? void 0 : productInfo.description) !== null && _b !== void 0 ? _b : '',
        currency: (_c = ctaArea === null || ctaArea === void 0 ? void 0 : ctaArea.currency) !== null && _c !== void 0 ? _c : 'EUR',
        price: formatPrice(isApc ? (_e = (_d = productAvailabilityInfo === null || productAvailabilityInfo === void 0 ? void 0 : productAvailabilityInfo.prices) === null || _d === void 0 ? void 0 : _d[productId]) === null || _e === void 0 ? void 0 : _e.activePriceValue : ctaArea === null || ctaArea === void 0 ? void 0 : ctaArea.price),
        item_category: '',
        index: '',
        variant: '',
      },
    ] }, addPageLoadDataInfoToAnalyticsEvent());
};
const checkForLongWordInString = (pillars, threshold) => pillars.some((pillar) => pillar.pillarLabel.split(' ').some((word) => word.length > threshold));
const checkForShowMore = (pillars, isLongWordPresent) => {
  const pillarsPerRow = isLongWordPresent ? 3 : 4;
  const isShowMoreRequired = pillars.length > pillarsPerRow;
  return { isShowMoreRequired, pillarsPerRow };
};
const fetchProductData = async ({ productId, localeCode, circularType, isPbs, }) => {
  store.dispatch(startLoading({ type: ACTION_TYPES.START_LOADING }));
  const countryCode = getCountry(localeCode);
  const languageCode = getLanguage(localeCode);
  try {
    const [productsAllResponse, ddcConfigResponse] = await Promise.all([
      SprykerProductsAll.getProductsAll({
        productId,
        languageCode,
        countryCode,
        brand: getBrandName(),
      }),
      SprykerDdcConfig.getDdcConfig({
        languageCode,
        countryCode,
        brand: getBrandName(),
      }),
    ]);
    if (productsAllResponse.error) {
      throw productsAllResponse.error;
    }
    const { data } = store.getState().product;
    let productsAllData = productsAllResponse.result;
    if (isPbs) {
      const { ctaArea, links, offlineStores } = data[CircularProductTypes.LINEAR].base;
      const updatedBase = Object.assign(Object.assign({}, productsAllResponse.result.base), { ctaArea,
        links,
        offlineStores });
      productsAllData = merge_1({}, productsAllResponse.result, { base: updatedBase });
    }
    store.dispatch(setCircularProductData(merge_1({}, { circularType }, productsAllData, { ddc: Object.assign(Object.assign({}, ddcConfigResponse.result), { productId }) })));
    store.dispatch(stopLoading({ type: ACTION_TYPES.STOP_LOADING }));
  }
  catch (error) {
    console.error(`[PES]: Error fetching product data:\n${error.message}`);
    store.dispatch(setError(error));
  }
};
const addPDPCTAClickGAEvent = (pdpClickGAEventParams) => {
  const { name, category, url, position } = pdpClickGAEventParams;
  const ctaClickGAParams = getCTAClickEventParams(name, category, url, position);
  triggerCtaClickEvent(ctaClickGAParams);
};
const StickyBarMapping = {
  [ECarouselRelation.compatibleSoftware]: ETabType.SOFTWARE_CAROUSEL,
  [ECarouselRelation.crossSellLife]: ETabType.LIFECYCLE_CAROUSEL,
  [ECarouselRelation.upsell]: ETabType.EXPLORE_CAROUSEL,
  [ECarouselRelation.crosssell]: ETabType.FREQUENTLY_BOUGHT_CAROUSEL,
};
const getStickyBarMapping = (relationType) => {
  return StickyBarMapping[relationType];
};

export { ExternalUrlConfigAction as E, _baseRest as _, addPDPCTAClickGAEvent as a, gatherDataForViewItemAnalyticsEvent as b, fetchProductData as c, setProductSelectorAvailability as d, getStickyBarMapping as e, formatPrice as f, generateExternalURL as g, _isIterateeCall as h, checkForLongWordInString as i, checkForShowMore as j, merge_1 as m, softwareDocumentsToSoftwareInfo as s };
